const doc = [({"en":({"js":({"admin":({"emails":({"admin_confirm_button":({"the_email_was_confirmed":"The email was confirmed."})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;